import { Button } from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import React from 'react'

export const EmptyStateSimpleBtn = ({ classes, onClick }) => {
  return (
    <Button
      variant="outlined"
      startIcon={<AddIcon />}
      onClick={onClick}
      className={classes.newCampaignBtn}
    >
      New Campaign
    </Button>
  )
}
